export default {
  unknown: 'Unknown',
};
